define('views/modules/calendar/favorite/favorite-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/layout',
    // views
    'views/parts/menu/menu-action',
    'views/modules/calendar/favorite/lists/favorite-list',
    'views/modules/calendar/favorite/edit/favorite-edit-panel',
    // templates
    'text!templates/modules/calendar/favorite/favorite-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    LayoutState,
    // views
    VMenuAction,
    VFavoriteList,
    VFavoriteEditPanel,
    // templates
    TFavoriteContent
) {

    /**
     * Generic favorite panel
     * @param  {String} type - one of: (calendar-activity|animated-session|animated-session-cardio|nutrilog)
     * @param  {Boolean} fixed - position of the 'apply favorite' button.
     */
    var VFavoriteContent = Backbone.View.extend({
        template: TFavoriteContent,

        regions: {
            root: ".favorite-content",
            menu: ".menu-actions",
            search: ".favorite-search",
            list: ".favorite-list",
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            var view = this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    radio: false,
                    collection: new Backbone.Collection([
                        { content: 'Load selected favorite', icon: "sl-icon-reload", itemClass: "pull-right load-favorite-button", style: 'display:none;', callback: this.onApplyFavoriteClick },
                    ]),
                    tooltip: { container: this.regions.root, }
                }),
                // search: new VTextBox({ label: 'Search', attribute: 'query' }),
                list: new VFavoriteList({ type: this.options.type }),
            };

            this.listenTo(view.list, {
                "favorite:select": this.onFavoriteSelect,
                "favorite:apply": this.applyFavorite,
                "favorite:edit": this.onFavoriteEdit,
            });
        },

        render: function() {
            this.$el.empty().append(this.template);

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.list, zone.$list);

            return this;
        },

        getSelected: function() {
            return this.view.list.getSelected();
        },

        applyFavorite: function(model) {
            var dataModel = this.model;
            model = model || this.getSelected();
            if (!model.isNew()) {
                //To be able to save without any change to the detail form in calendar-item-panel-content.js
                if (model.get('type') === "calendar-activity") {
                  dataModel.set('isFavorite', true);
                }
                dataModel.set(model.get('data'));
                dataModel.trigger('favorite:applied');
            }
            this.trigger('favorite:applied');
            return this;
        },

        showEditPanel: function(model) {
            if (!this.view.edit) {
                this.view.edit = new VFavoriteEditPanel({
                    type: this.options.type,
                    item: model,
                });
                this.listenTo(this.view.edit, 'form:success', this.onFavoriteUpdate);
            }

            this.view.edit.resetModel(
                _.extend({
                    data: model
                }, model && model.attributes || model)
            );
            LayoutState.stackInfo(this.view.edit);
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onCreateFavoriteAction: function() {
            this.showEditPanel();
        },

        ////////////
        // events //
        ////////////

        onApplyFavoriteClick: function(e) {
            this.applyFavorite();
        },

        onFavoriteEdit: function(model) {
            this.showEditPanel(model);
        },

        onFavoriteSelect: function(view, model) {
            var menuView = this.view.menu;
            menuView.toggleHiddenButton('.load-favorite-button', !model.isNew());
        },

        onFavoriteUpdate: function(model) {
            this.view.list.getCollection().set(model, { remove: false });
        },

    });

    return VFavoriteContent;

});

